import { render, staticRenderFns } from "./onboarding-settings-form.vue?vue&type=template&id=5d9b9cf1"
import script from "./onboarding-settings-form.vue?vue&type=script&lang=js"
export * from "./onboarding-settings-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports